"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WrapAttachmentDTO = void 0;
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const CommentSupplierAttachmentDTO_1 = require("./CommentSupplierAttachmentDTO");
const DocumentSupplierAttachmentDTO_1 = require("./DocumentSupplierAttachmentDTO");
const SupplierAttachmentDTO_1 = require("./SupplierAttachmentDTO");
const TestSupplierAttachmentDTO_1 = require("./TestSupplierAttachmentDTO");
class WrapAttachmentDTO {
}
exports.WrapAttachmentDTO = WrapAttachmentDTO;
__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => SupplierAttachmentDTO_1.SupplierAttachmentDTO, {
        discriminator: {
            property: 'attachmentType',
            subTypes: [
                {
                    name: 'comment',
                    value: CommentSupplierAttachmentDTO_1.CommentSupplierAttachmentDTO
                },
                {
                    name: 'document',
                    value: DocumentSupplierAttachmentDTO_1.DocumentSupplierAttachmentDTO
                },
                {
                    name: 'test',
                    value: TestSupplierAttachmentDTO_1.TestSupplierAttachmentDTO
                }
            ]
        },
        keepDiscriminatorProperty: true
    }),
    __metadata("design:type", Object)
], WrapAttachmentDTO.prototype, "attachment", void 0);
